// Payment status colors mapping
export const PAYMENT_STATUS_COLORS = {
  created: 'blue',
  processing: 'processing',
  paid: 'success',
  failed: 'error',
  refunded: 'cyan',
  partially_refunded: 'geekblue',
  disputed: 'volcano',
  default: 'default'
};

// Table pagination defaults
export const DEFAULT_PAGINATION = {
  current: 1,
  pageSize: 10,
  total: 0
}; 